export const errorCodes = {
  403: {
    forbidden: {
      welcomeQuestionsNotAnswered: "forbidden.welcome_questions_not_answered",
      userIsSanctioned: "forbidden.user_is_sanctioned",
      emptyCustomFields: "forbidden.empty_custom_fields",
      invalidUserRole: "forbidden.invalid_user_role",
      pausePortal: "forbidden.pause_portal",
      lockedPortal: "forbidden.locked_portal",
      userNotAllowedToAccessPlus: "forbidden.user_not_allowed_to_access_plus",
      userNotMemberInBranch: "forbidden.user_not_member_in_branch",
      branchInactive: "forbidden.branch_inactive",
      userNotFound: "not_found.user_not_found",
      userNotActive: "conflict.user_not_active",
    },
  },
};

export const logoutErrorsStatuses = [403, 404, 409];
